import { distinctUntilChanged, map } from "rxjs/operators";
export default (state$) => {
    if (process.env.NODE_ENV === "development") {
        return;
    }
    const didChangeConnectionStatus$ = state$.pipe(map((state) => state.connection.state.connected), distinctUntilChanged());
    // https://stackoverflow.com/questions/1119289/how-to-show-the-are-you-sure-you-want-to-navigate-away-from-this-page-when-ch/1119324#1119324
    didChangeConnectionStatus$.subscribe((connected) => (window.onbeforeunload = connected ? () => true : null));
};
